import DiscountEmailCaptureApp from '@/apps/DiscountEmailCaptureApp.vue'
import { createApp } from 'vue'
export default function () {
  const containerEl = document.createElement('div')
  document.body.appendChild(containerEl)
  const app = createApp(DiscountEmailCaptureApp)
  app.mount(containerEl)
}
